import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** Placeholder linked journey row until the customer journeys API is wired. */
export type CustomerProfileJourneyListItem = {
    id: Uuid;
    eventContainerTemplateId: Uuid | null;
    title: string;
    statusLabel: string;
    createdAtLabel: string;
    isLinked: boolean;
};

export const MOCK_CUSTOMER_PROFILE_JOURNEYS: Array<CustomerProfileJourneyListItem> = [
    {
        id: "a1b2c3d4-e5f6-4789-a012-3456789abcde" as Uuid,
        eventContainerTemplateId: null,
        title: "Lifecycle — North Showroom",
        statusLabel: "Live",
        createdAtLabel: "12 Jan 2026",
        isLinked: false,
    },
    {
        id: "b2c3d4e5-f6a7-8901-bcde-f12345678901" as Uuid,
        eventContainerTemplateId: null,
        title: "Lifecycle — Online enquiry",
        statusLabel: "Converted",
        createdAtLabel: "28 Dec 2025",
        isLinked: false,
    },
    {
        id: "c3d4e5f6-a7b8-9012-cdef-123456789012" as Uuid,
        eventContainerTemplateId: null,
        title: "Lifecycle — Walk-in follow-up",
        statusLabel: "Non-Engaged",
        createdAtLabel: "04 Nov 2025",
        isLinked: false,
    },
];
